// What the Stats shell and its tabs share: the visible-tab poll, the duration
// wording and the bounded error code. Deliberately knows nothing about React.

// A hidden tab is not a vendor watching their horses. Polling every few seconds
// so the counts stay under ten seconds old is only affordable while someone is
// actually looking, and returning to the tab refreshes at once rather than
// waiting out the remainder of an interval.
export function visiblePoll(load, every) {
  const tick = () => {
    if (document.visibilityState !== "hidden") load();
  };
  const onVisible = () => {
    if (document.visibilityState === "visible") load();
  };
  document.addEventListener("visibilitychange", onVisible);
  const id = setInterval(tick, every);
  return () => {
    document.removeEventListener("visibilitychange", onVisible);
    clearInterval(id);
  };
}

// Repository reports X-ray viewing time in milliseconds. Seconds on their own
// stop being readable the moment a vet spends more than a minute on a horse —
// "612s" is a number the reader has to divide before it means anything.
export const duration = (value) => {
  if (value == null) return "—";
  const total = Math.round(value / 1000);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  if (hours) return `${hours}h ${String(minutes).padStart(2, "0")}m`;
  if (minutes) return `${minutes}m ${String(seconds).padStart(2, "0")}s`;
  return `${seconds}s`;
};

// A null count is "not reported", never zero.
export const count = (value) => (value == null ? "—" : Number(value).toLocaleString());

// An error body is a bounded server code or nothing; anything else becomes the
// HTTP status, so provider detail never reaches the screen.
export function errorCode(body, status) {
  const candidate = typeof body?.error === "string"
    ? body.error
    : body?.error?.code || body?.errors?.[0]?.code;
  return typeof candidate === "string" && /^[A-Za-z0-9_.-]{1,64}$/.test(candidate)
    ? candidate
    : `HTTP_${status}`;
}
